import React from "react"

const Layout: React.FunctionComponent = ({ children }) => (
  <html lang="en">
    <head>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta http-equiv="X-UA-Compatible" content="ie=edge" />
      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.3.1/css/all.css"
        integrity="sha384-mzrmE5qonljUremFsqc01SB46JvROS7bZs3IO2EmfFsd15uHvIt+Y8vEf7N7fWAU"
        crossOrigin="anonymous"
      />
      <link
        href="https://unpkg.com/tailwindcss@next/dist/tailwind.min.css"
        rel="stylesheet"
      />
    </head>
    <body className="bg-gray-100 font-sans leading-normal tracking-normal">
      {children}
    </body>
  </html>
)

export default Layout
